import { useState } from "react";

const FORM_ADDR = "https://readdy.ai/api/form/dag3jl1tto0ceqqnhl40";

export default function Newsletter() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [msg, setMsg] = useState("");

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = String(fd.get("website_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      setMsg("订阅成功，感谢关注塌房观察室。");
      form.reset();
      return;
    }
    fd.delete("website_alt");
    try {
      const res = await fetch(FORM_ADDR, { method: "POST", body: fd });
      const text = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(text);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || text;
      const ok = res.ok && parsed?.code === "OK";
      if (ok) {
        setStatus("success");
        setMsg("订阅成功，最新「塌房周刊」将准时送达你的邮箱。");
        form.reset();
      } else {
        setStatus("error");
        setMsg(serverMsg || "订阅失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMsg("网络似乎开小差了，请稍后再试。");
    }
  };

  return (
    <section className="relative overflow-hidden bg-ink-900 py-14 md:py-20">
      <div className="absolute inset-0 opacity-[0.07]"
        style={{ backgroundImage: "radial-gradient(circle at 80% 20%, #E0542E 0, transparent 40%), radial-gradient(circle at 15% 80%, #D9AF59 0, transparent 40%)" }}
      ></div>
      <div className="relative z-10 mx-auto max-w-6xl px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center">
          <div>
            <p className="inline-flex items-center gap-2 text-sm font-semibold tracking-wide uppercase text-gold-400">
              <span className="inline-block w-6 h-px bg-current"></span> DISILLUSION WEEKLY
            </p>
            <h2 className="mt-3 font-display text-3xl md:text-4xl leading-tight text-paper-50">
              每周一封，吃瓜不再被热搜牵着走
            </h2>
            <p className="mt-3 text-paper-50/70 leading-relaxed">
              订阅《塌房观察周刊》，每周精选最值得复盘的人设崩塌事件与行业深度解读，
              用冷静的视角，帮你离真相更近一步。免费、无打扰，随时可退订。
            </p>
          </div>

          <div>
            <form
              onSubmit={onSubmit}
              data-readdy-form="塌房观察室周刊订阅"
              className="w-full rounded-2xl border border-paper-50/15 bg-paper-50/[0.06] p-5 md:p-6"
            >
              <label htmlFor="sub-email" className="text-sm text-paper-50/85 font-medium">
                你的邮箱
              </label>
              <div className="mt-2 flex flex-col sm:flex-row gap-2">
                <input
                  id="sub-email"
                  name="email"
                  type="email"
                  required
                  autoComplete="email"
                  placeholder="you@example.com"
                  className="flex-1 min-w-0 rounded-full border border-paper-50/20 bg-ink-950/60 px-5 py-3 text-paper-50 placeholder:text-paper-50/40 outline-none focus:border-coral-400 focus:ring-2 focus:ring-coral-500/30 text-sm"
                />
                <button
                  type="submit"
                  className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-coral-500 hover:bg-coral-600 text-white font-semibold px-6 py-3 transition-colors cursor-pointer"
                >
                  立即订阅 <i className="ri-send-plane-line"></i>
                </button>
              </div>
              <div className="field-guard">
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>

              <div className="mt-3 min-h-5">
                {status === "success" && (
                  <p className="text-sm text-gold-400 inline-flex items-center gap-1.5">
                    <i className="ri-checkbox-circle-line"></i> {msg}
                  </p>
                )}
                {status === "error" && (
                  <p className="text-sm text-coral-300 inline-flex items-center gap-1.5">
                    <i className="ri-error-warning-line"></i> {msg}
                  </p>
                )}
              </div>
              <p className="text-xs text-paper-50/45">我们尊重你的隐私，邮件中不会夹带任何广告骚扰。</p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}